import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function Terms() {
    return (
        <div className="min-h-screen bg-white">
            <div className="max-w-3xl mx-auto px-4 sm:px-6 py-16 md:py-24">
                <Link
                    to="/"
                    className="inline-flex items-center gap-2 text-sm text-slate-600 hover:text-primary mb-8"
                    data-testid="terms-back-link"
                >
                    <ArrowLeft className="w-4 h-4" /> Back
                </Link>
                <h1 className="text-4xl md:text-5xl font-bold tracking-tight mb-2">
                    Terms of Service
                </h1>
                <p className="text-sm text-slate-500 mb-10">
                    Placeholder page — full terms coming soon.
                </p>
                <div className="prose prose-slate max-w-none text-slate-700 leading-relaxed">
                    <p>
                        These terms cover the audit conversation booked through
                        this page and any subsequent engagement with GrowthX AI
                        Partners LLP (India) or OneBlockMedia Pty Ltd
                        (Australia).
                    </p>
                    <p>
                        Audit scope, deliverables, pricing, and data-access
                        permissions are confirmed in a separate Statement of
                        Work after the 30-minute call. No commitment is created
                        by booking a call.
                    </p>
                    <p>
                        For any question, write to info@growthx.digital.
                    </p>
                </div>
            </div>
        </div>
    );
}
